const keys = {
  homeAmenities: {
    titles: {
      hasHeatingBeenRenovated: 'Was your heating system replaced in the last {{0}} years?',
      hasDetachedStructure: 'Are there any detached structures (other than a garden shed or a garage)?',
      hasSepticTank: 'Is there a septic tank?',
      hasSumpPump: 'Is there a sump-pump?',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
